import * as ReactDOMClient from "react-dom/client";
import "./i18n/i18n";

import App from "./App";

// In a multilanguage app, the CSS library should be conditionally add but with import, it is not possible so we use CDN instead
// import "bootstrap/dist/css/bootstrap.rtl.min.css";
// import "bootstrap/dist/css/bootstrap.min.css";

import "./index.css";

const root = ReactDOMClient.createRoot(document.getElementById("root"));
root.render(
  <>
    <App />
  </>,
);
